import { Component, Input } from '@angular/core';
import { IMetric, IReportDetails, IReviewItem, ISidebarSection } from '../../driver-background-check.view-models';
import { DriverBackgroundCheckStateService } from '../../driver-background-check-state.service';

@Component({
  selector: 'app-bgc-sidebar',
  templateUrl: './bgc-sidebar.component.html',
  styleUrls: ['./bgc-sidebar.component.scss', '../../driver-background-check.component.scss']
})
export class BgcSidebarComponent {
  @Input() sections: ISidebarSection[];
  @Input() activeSection: string;
  @Input() metrics: IMetric[];
  @Input() itemsRequiringReview: IReviewItem[];
  @Input() reportDetails: IReportDetails;

  constructor(public stateService: DriverBackgroundCheckStateService) {}

  trackBySection(index: number, section: ISidebarSection): string {
    return section.id;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-sidebar/bgc-sidebar.component.ts